<u-button #buttonRef type="button" [onClick]="handleButtonClick" class="calendar-button" [ngClass]="buttonClasses()">
  <fa-icon [icon]="faCalendar" />&nbsp;<span data-translate="calendar" i18n="@@calendar">calendar</span>
</u-button>

<p-popover #popover styleClass="calendar-popover" [appendTo]="'body'" [dismissable]="true">
  <p-menu #menu [model]="calendarOptions" styleClass="calendar-menu">
    <ng-template pTemplate="item" let-item>
      @if (item.hasCustomAction) {
        <a pRipple (click)="customAction(item)">
          <fa-icon [icon]="item.fontAwsemeIcon" />&nbsp;<span>{{ item.platform }}</span>
        </a>
      } @else {
        <a pRipple [href]="item.url" target="_blank" (click)="tracking(item)">
          <fa-icon [icon]="item.fontAwsemeIcon" />&nbsp;<span>{{ item.platform }}</span>
        </a>
      }
    </ng-template>
  </p-menu>
</p-popover>
